<div class="site-icon-wrapper" *ngIf="type; else oldVersion">
  <span class="icons" [class.grouped]="isGroup">
    <img [src]="'assets/img/site_icon/v2/' + (isGroup ? 'groups/' : '') + typeName + '.png'" />
  </span>
  <!-- Optional pass a label as transclude -->
  <span appMatTooltipShowIfTruncated [matTooltip]="tooltipLabel" class="content" [class.alc-ellipsis]="tooltipLabel">
    <ng-content></ng-content>
  </span>
</div>
<ng-template #oldVersion>
  <span data-testid="site-icon" class="alc-site-icon" [ngClass]="cssClass"></span>
  <span data-testid="site-name" class="alc-ellipsis">{{ siteName }}</span>
</ng-template>
